import Head from "next/head";
import React from "react";

type SingleCriticalImageProps = {
  className?: string;
  dimensions?: [number, number];
} & React.ImgHTMLAttributes<HTMLImageElement>;

export default function SingleCriticalImage({
  src,
  alt,
  className,
  dimensions,
  ...props
}: SingleCriticalImageProps) {
  return (
    <>
      <Head>
        <link rel="preload" as="image" href={src} />
      </Head>

      <img
        src={src}
        alt={alt ? alt : "Image without Alt Text"}
        className={className ? className : ""}
        {...props}
      />
    </>
  );
}
